import { useState } from "react";
import styles from "./track-booking.module.css";
import Loader from "../../../admin/components/Loader";
import axios from "axios";
import { authData } from "../../../admin/components/GetAuth";
import dayjs from "dayjs";
import { Alert, Snackbar } from "@mui/material";

function TrackBooking() {
  const auth = authData();
  const [loading, setLoading] = useState(false);
  const [bookigPhone, setBookigPhone] = useState("");
  const [bookigIdNew, setBookigIdNew] = useState("");
  const [bookingData, setBookingData] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  const searchBooking = () => {
    setBookingData(null);
    if (bookigPhone === '') {
      setSnackbarOpen(true);
      setSnackbarMessage("Please enter phone!");
      setSnackbarType("error");

      return false;
    }

    if (bookigIdNew === '') {
      setSnackbarOpen(true);
      setSnackbarMessage("Please enter bookig Id!");
      setSnackbarType("error");

      return false;
    }

    setLoading(true);

    axios.post(process.env.REACT_APP_API_URL + "v1/tarck-booking-details", { phone: bookigPhone, bookId: bookigIdNew }, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === 'ERROR') {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("error");
      } else {
        setBookingData(response.data.data);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />

    <div className={`${styles.BannerSec}`}>
      <img src="/images/contact-us-banner1.jpg" alt="" />
      <div className={`${styles.BannerTitleCU}`}>
        <div className={`${styles.Container}`}>
          <h1 className={`${styles.Heading}`}>Track Booking</h1>
        </div>
      </div>
    </div>

    <div className={`${styles.MainDivCustomer}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.CusRow}`}>
          <div className={`${styles.CustomerDeSec}`}>
            <div className={`${styles.UserProCard2}`}>
              <div className={`${styles.HalfSec}`}>
                <p className={`${styles.Heading} ${styles.HeadingTT}`}>Order Details</p>
                <div className={`${styles.SearchSec}`}>
                  <input type="text" placeholder="Enter phone" onChange={(e) => setBookigPhone(e)} />
                  <input type="text" placeholder="Enter Your Booking Id" onChange={(e) => setBookigIdNew(e.target.value)} />
                  <button onClick={(e) => searchBooking()}>Search</button>
                </div>
                {bookingData && (<>
                  <p className={`${styles.TitleRe}`}>Search Results :</p>
                  <ul className={`${styles.SearchDe}`}>
                    <li>
                      <span>Order ID :</span> {bookingData?.booking_id}
                    </li>
                    <li>
                      <span>Order placed on :</span> {dayjs(bookingData?.created_at).format("DD MMM YYYY")}
                    </li>
                    <li>
                      <span>Contact No :</span> {bookingData?.pickup_details?.phone}
                    </li>
                  </ul>
                </>)}
              </div>

              {bookingData && (<div className={`${styles.HalfSecTwo}`}>
                <p className={`${styles.Heading} ${styles.HeadingTT}`}>Shipment Tracking</p>
                {parseInt(bookingData?.status) !== -1 && <>
                  <p className={`${styles.EstiTitle}`}>{parseInt(bookingData?.status) === 7 ? "Deliverred At" : "Estimated Delivery Date"}</p>
                  <p className={`${styles.TrasitDT}`}>{bookingData?.estimated_delivery_date ? dayjs(bookingData?.estimated_delivery_date).format("ddd, MMM DD") : dayjs(bookingData?.booking_date).add(1, 'month').format("ddd, MMM DD")}</p>
                </>}
                {parseInt(bookingData?.status) === -1 && <p className={`${styles.TrasitStatusT}`}>
                  Status : <span className={`${styles.SpanCancel}`}>CANCELLED</span>
                </p>}

                {(parseInt(bookingData?.status) === 0 || parseInt(bookingData?.status) === 1) && <p className={`${styles.TrasitStatusT}`}>
                  Status : <span className={`${styles.SpanBooked}`}>BOOKED</span>
                </p>}

                {(parseInt(bookingData?.status) === 2 || parseInt(bookingData?.status) === 3) && <p className={`${styles.TrasitStatusT}`}>
                  Status : <span className={`${styles.SpanBooked}`}>PICKED UP</span>
                </p>}

                {(parseInt(bookingData?.status) === 4 || parseInt(bookingData?.status) === 5 || parseInt(bookingData?.status) === 6) && <p className={`${styles.TrasitStatusT}`}>
                  Status : <span className={`${styles.SpanShipped}`}>TRANSIT</span>
                </p>}

                {(parseInt(bookingData?.status) === 7) && <p className={`${styles.TrasitStatusT}`}>
                  Status : <span className={`${styles.SpanDelivered}`}>DELIVERRED</span>
                </p>}

                {bookingData && bookingData?.trackingDetails && <ul className={`${styles.StatusUL}`}>

                  {bookingData?.trackingDetails?.map(item => {
                    return item?.is_completed ? <li className={`${styles.Complete}`}>
                      <p className={`${styles.StatTT}`}>{item?.status_text}</p>
                      <p className={`${styles.StatTTN}`}>{dayjs(item?.datetime).format("DD MMM YYYY LT")}</p>
                    </li> : <li className={`${styles.StatTT}`}>
                      <p className={`${styles.StatTT}`}>{item?.status_text}</p>
                    </li>
                  })}

                </ul>}
              </div>)}

              {bookingData && bookingData?.products?.length && (<div className={`${styles.StatFullSec}`}>
                <p className={`${styles.Heading} ${styles.HeadingTT}`}>Order Details</p>
                <div className={`${styles.TableSec}`}>
                  <table>
                    <tr>
                      <td className={`${styles.TableHead}`}>Pickup Id</td>
                      <td className={`${styles.TableHead}`}>Item</td>
                      <td className={`${styles.TableHead}`}>Fragile</td>
                      <td className={`${styles.TableHead}`}>Estimated Value</td>
                      <td className={`${styles.TableHead}`}>Status</td>
                    </tr>
                    {bookingData?.products?.map((item, index) => {
                      return (<tr key={index}>
                        <td className={`${styles.TableCon}`}>{item?.item_id}</td>
                        <td className={`${styles.TableCon}`}>{item?.product_title}</td>
                        <td className={`${styles.TableCon}`}>{item?.is_fragile ? "Yes" : "No"}</td>
                        <td className={`${styles.TableCon}`}>£{parseFloat(item?.sub_amount)?.toFixed(2)}</td>
                        <td className={`${styles.TableCon}`}>{item?.status_text !== '' ? item?.status_text : bookingData?.status_text}</td>
                      </tr>);
                    })}
                  </table>
                </div>
              </div>)}

            </div>
          </div>
        </div>
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
}

export default TrackBooking;